import { render } from "./IconDocuments.vue?vue&type=template&id=021031fa&lang=html"
import script from "./IconDocuments.vue?vue&type=script&lang=js"
export * from "./IconDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__